import { c as _c } from "react/compiler-runtime";
import { EmptyPage } from "@components/common/empty-page/empty-page";
import { CardSelectorSkeleton } from "@components/common/skeleton-loading/card-selector-skeleton";
import { CardSelector, Text, EmptyIcon, Divider } from "@flat-ui";
import { useStripeProducts } from "@hooks/use-stripe-products";
import { Grid, Stack } from "@mui-wrapper";
import { CreditFeatureItem } from "@pages/settings/subscription-settings/credits/credit-feature-item";
import { CreditPurchase } from "@pages/settings/subscription-settings/credits/credit-purchase";
import { RequestCreditQuote } from "@pages/settings/subscription-settings/credits/request-credit-quote";
import { CREDIT_DISPLAY_NAME, CREDITS_DISPLAY_NAME } from "@src/constants/credit-constants";
import { fetchingSdbCompanyFlagsSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { convertStripeProductToPackageCardItem, formatStripeDisplayPrice } from "@utils/stripe-product-utils";

/** List of credit-related features */
const CREDIT_FEATURES = [`Use ${CREDITS_DISPLAY_NAME} to generate floorplans`, `Purchase ${CREDITS_DISPLAY_NAME} tailored to your needs`, `Use ${CREDITS_DISPLAY_NAME} within 12 months`];
/** Render the credit packages list for purchasing credits. */
export function CreditPackages(t0) {
  const $ = _c(76);
  const {
    selectedPackage,
    setSelectedPackage
  } = t0;
  const {
    fetchSelectedCompanyContext,
    isFetchingCompanySubscriptions
  } = useAppSelector(fetchingSdbCompanyFlagsSelector);
  const {
    stripeProducts,
    isLoading: isLoadingProducts
  } = useStripeProducts();
  let t1;
  if ($[0] !== stripeProducts) {
    t1 = convertStripeProductToPackageCardItem(stripeProducts);
    $[0] = stripeProducts;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const cardItems = t1;
  const isLoading = isLoadingProducts || fetchSelectedCompanyContext === "pending" || isFetchingCompanySubscriptions;
  if (cardItems.length === 0 && !isLoadingProducts) {
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = <EmptyPage title={`No ${CREDIT_DISPLAY_NAME} packages available`} subtitle="Please check back later or contact support for assistance." icon={EmptyIcon} />;
      $[2] = t2;
    } else {
      t2 = $[2];
    }
    return t2;
  }
  let t2;
  if ($[3] !== setSelectedPackage || $[4] !== stripeProducts) {
    t2 = function handleOnSelect(productId) {
      const selectedProduct = stripeProducts.find(product => product.id === productId);
      if (selectedProduct) {
        setSelectedPackage(selectedProduct);
      }
    };
    $[3] = setSelectedPackage;
    $[4] = stripeProducts;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  const handleOnSelect = t2;
  let T0;
  let T1;
  let T2;
  let T3;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[6] !== cardItems || $[7] !== handleOnSelect || $[8] !== isLoading || $[9] !== selectedPackage) {
    const reducedPrice = selectedPackage ? (parseFloat(selectedPackage.price.price) / 2).toString() : "";
    if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
      t16 = <Stack sx={{
        alignItems: "center",
        marginTop: {
          sm: "0px",
          md: "50px"
        },
        marginBottom: "50px"
      }}><Text variant="heading24"> Add {CREDITS_DISPLAY_NAME}</Text><Text variant="bodyM">Select the {CREDIT_DISPLAY_NAME} package that best fits your needs.</Text></Stack>;
      $[28] = t16;
    } else {
      t16 = $[28];
    }
    T3 = Grid;
    t13 = true;
    if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = {
        marginX: "auto",
        width: {
          lg: "70%"
        }
      };
      $[29] = t14;
    } else {
      t14 = $[29];
    }
    let t17;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
      t17 = {
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
        xl: 6
      };
      $[30] = t17;
    } else {
      t17 = $[30];
    }
    if ($[31] !== cardItems || $[32] !== handleOnSelect || $[33] !== isLoading || $[34] !== selectedPackage?.id) {
      t15 = <Grid component="div" size={t17}><Stack>{isLoading ? <CardSelectorSkeleton /> : <CardSelector cardDirection="column" cardItems={cardItems} selectedValue={selectedPackage?.id} onSelect={handleOnSelect} />}</Stack></Grid>;
      $[31] = cardItems;
      $[32] = handleOnSelect;
      $[33] = isLoading;
      $[34] = selectedPackage?.id;
      $[35] = t15;
    } else {
      t15 = $[35];
    }
    T2 = Grid;
    t11 = "div";
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = {
        xs: 12,
        sm: 6,
        md: 6,
        lg: 6,
        xl: 6
      };
      $[36] = t12;
    } else {
      t12 = $[36];
    }
    T1 = Stack;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = {
        backgroundColor: "surfaces.secondary",
        borderRadius: "4px",
        marginTop: {
          xs: "15px",
          sm: "0px"
        },
        marginLeft: {
          xs: "0px",
          sm: "15px"
        },
        padding: "32px"
      };
      t7 = <Text variant="heading16">Check out</Text>;
      $[37] = t6;
      $[38] = t7;
    } else {
      t6 = $[37];
      t7 = $[38];
    }
    if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <Divider sx={{
        marginY: "12px"
      }} />;
      t9 = CREDIT_FEATURES.map(_temp);
      $[39] = t8;
      $[40] = t9;
    } else {
      t8 = $[39];
      t9 = $[40];
    }
    if ($[41] === Symbol.for("react.memo_cache_sentinel")) {
      t10 = <Divider sx={{
        marginY: "12px"
      }} />;
      $[41] = t10;
    } else {
      t10 = $[41];
    }
    T0 = Stack;
    if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = {
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        marginBottom: "24px"
      };
      t4 = <Text variant="bodyM">Total</Text>;
      $[42] = t3;
      $[43] = t4;
    } else {
      t3 = $[42];
      t4 = $[43];
    }
    t5 = selectedPackage?.price.price && <Text variant="bodyM">{formatStripeDisplayPrice(reducedPrice)}</Text>;
    $[6] = cardItems;
    $[7] = handleOnSelect;
    $[8] = isLoading;
    $[9] = selectedPackage;
    $[10] = T0;
    $[11] = T1;
    $[12] = T2;
    $[13] = T3;
    $[14] = t10;
    $[15] = t11;
    $[16] = t12;
    $[17] = t13;
    $[18] = t14;
    $[19] = t15;
    $[20] = t16;
    $[21] = t3;
    $[22] = t4;
    $[23] = t5;
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
    $[27] = t9;
  } else {
    T0 = $[10];
    T1 = $[11];
    T2 = $[12];
    T3 = $[13];
    t10 = $[14];
    t11 = $[15];
    t12 = $[16];
    t13 = $[17];
    t14 = $[18];
    t15 = $[19];
    t16 = $[20];
    t3 = $[21];
    t4 = $[22];
    t5 = $[23];
    t6 = $[24];
    t7 = $[25];
    t8 = $[26];
    t9 = $[27];
  }
  let t17;
  if ($[44] !== T0 || $[45] !== t3 || $[46] !== t4 || $[47] !== t5) {
    t17 = <T0 sx={t3}>{t4}{t5}</T0>;
    $[44] = T0;
    $[45] = t3;
    $[46] = t4;
    $[47] = t5;
    $[48] = t17;
  } else {
    t17 = $[48];
  }
  let t18;
  let t19;
  if ($[49] !== selectedPackage) {
    t18 = <CreditPurchase selectedPackage={selectedPackage} />;
    t19 = <RequestCreditQuote selectedPackage={selectedPackage} />;
    $[49] = selectedPackage;
    $[50] = t18;
    $[51] = t19;
  } else {
    t18 = $[50];
    t19 = $[51];
  }
  let t20;
  if ($[52] !== T1 || $[53] !== t10 || $[54] !== t17 || $[55] !== t18 || $[56] !== t19 || $[57] !== t6 || $[58] !== t7 || $[59] !== t8 || $[60] !== t9) {
    t20 = <T1 sx={t6}>{t7}{t8}{t9}{t10}{t17}{t18}{t19}</T1>;
    $[52] = T1;
    $[53] = t10;
    $[54] = t17;
    $[55] = t18;
    $[56] = t19;
    $[57] = t6;
    $[58] = t7;
    $[59] = t8;
    $[60] = t9;
    $[61] = t20;
  } else {
    t20 = $[61];
  }
  let t21;
  if ($[62] !== T2 || $[63] !== t11 || $[64] !== t12 || $[65] !== t20) {
    t21 = <T2 component={t11} size={t12}>{t20}</T2>;
    $[62] = T2;
    $[63] = t11;
    $[64] = t12;
    $[65] = t20;
    $[66] = t21;
  } else {
    t21 = $[66];
  }
  let t22;
  if ($[67] !== T3 || $[68] !== t13 || $[69] !== t14 || $[70] !== t15 || $[71] !== t21) {
    t22 = <T3 container={t13} sx={t14}>{t15}{t21}</T3>;
    $[67] = T3;
    $[68] = t13;
    $[69] = t14;
    $[70] = t15;
    $[71] = t21;
    $[72] = t22;
  } else {
    t22 = $[72];
  }
  let t23;
  if ($[73] !== t16 || $[74] !== t22) {
    t23 = <>{t16}{t22}</>;
    $[73] = t16;
    $[74] = t22;
    $[75] = t23;
  } else {
    t23 = $[75];
  }
  return t23;
}
function _temp(text, index) {
  return <CreditFeatureItem key={index} featureText={text} />;
}